import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../productPageStyle.js";
import SectionHead from "./SectionHead.js";

const useStyles = makeStyles(styles);

/**
 * B-01 §7 in full, all seven rows.
 *
 * The Skinlyzer band compressed this into one sentence, and that is the
 * omission this page exists to fix. §26.2 calls reading more into the mark
 * "kiterjesztő értelmezés", so the limits get the same typographic weight as
 * the claim — a numbered section of their own, not a footnote.
 *
 * The red is dried correction ink: numerals, one italic word, and nothing
 * else. These rows are the honest boundary of the mark, not an error state,
 * so they must never be filled or badged like a warning.
 */
export default function LimitsSection({ t, num }) {
  const classes = useStyles();

  const title = (
    <React.Fragment>
      {t.certNotTitleBefore}
      <span className={classes.titleEm}>{t.certNotTitleEmphasis}</span>
      {t.certNotTitleAfter}
    </React.Fragment>
  );

  return (
    <section id="section-limits" className={classes.section}>
      <SectionHead num={num} title={title} accent />
      <p className={classes.sectionIntro}>{t.certNotIntro}</p>
      <div className={classes.ledger}>
        {t.certNotRows.map((row, i) => (
          <div className={classes.ledgerRow} key={row.claim}>
            <span className={classes.ledgerNum}>
              {String(i + 1).padStart(2, "0")}
            </span>
            <div className={classes.ledgerCell}>
              <p className={classes.ledgerClaim}>{row.claim}</p>
              <p className={classes.ledgerWhy}>{row.why}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
